import { render, staticRenderFns } from "./AdditionalCoverageDetailsForm.vue?vue&type=template&id=964380b4&"
import script from "./AdditionalCoverageDetailsForm.vue?vue&type=script&lang=js&"
export * from "./AdditionalCoverageDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports